/** Display labels for the backend's Smart Preplan mileage band identifiers. */
export const MILEAGE_BAND_OPTIONS = [
  { value: '1', label: '1: 0–25 miles' },
  { value: '2', label: '2: 26–50 miles' },
  { value: '3', label: '3: 51–100 miles' },
  { value: '4', label: '4: 101–150 miles' },
  { value: '5', label: '5: 151+ miles' },
  { value: '0', label: 'Unknown mileage' },
];

export function mileageBandLabel(band: number | null | undefined): string {
  return MILEAGE_BAND_OPTIONS.find(option => option.value === String(band ?? 0))?.label ?? 'Unknown mileage';
}

export function capacityMileageBandLabel(band: string): string {
  const keys = ['LOCAL 0-25', 'LOCAL 26-50', 'LOCAL 51-100', 'OTR 101-150', 'OTR 151+'];
  const index = keys.indexOf(band);
  return index < 0 ? 'Unknown mileage' : mileageBandLabel(index + 1);
}
